// auth-constants.ts — 004-dual-login-2fa (révisé selon FRONTEND_AUTH_GUIDE.md)
// Constantes métier pour l'authentification locale TOTP.

/** Longueur du code TOTP (Google Authenticator) */
export const TOTP_CODE_LENGTH = 6;

/** Format des codes de secours : XXXXX-XXXXX (11 caractères avec tiret) */
export const BACKUP_CODE_PATTERN = /^[A-Z0-9]{5}-[A-Z0-9]{5}$/;

/** Clé sessionStorage pour le JWT full-access (auth email/password + TOTP) */
export const LOCAL_AUTH_TOKEN_KEY = "auth_token";

/** Selected authentication provider for the current browser session */
export const AUTH_METHOD_KEY = "auth_method";

/** Event emitted when the selected authentication provider changes */
export const AUTH_METHOD_CHANGED_EVENT = "auth-method-changed";

/** Event emitted when a protected API request no longer has a valid session */
export const AUTH_EXPIRED_EVENT = "auth-expired";

/** Durée d'expiration du lien de réinitialisation de mot de passe (minutes) */
export const RESET_PASSWORD_EXPIRY_MINUTES = 30;

/** Durée de vie du token full-access local en heures (schedule re-login avant expiry) */
export const LOCAL_TOKEN_LIFETIME_HOURS = 48;

/** Durée du verrouillage MFA, alignée sur LocalAuth:MfaLockoutTimeSpanMinutes du back-end */
export const MFA_LOCKOUT_DURATION_MINUTES = 15;

/**
 * Longueur minimale du mot de passe pour les comptes locaux (email/mot de
 * passe), alignée sur la politique Identity du back-end (appsettings
 * LocalAuth:RequiredLength) : 12 caractères, majuscule, minuscule, chiffre,
 * caractère spécial obligatoires.
 */
export const LOCAL_PASSWORD_MIN_LENGTH = 12;
